import { unleash } from '../../unleash';
import { config } from '../../../config';
import { isTruthy } from '../../../utils/types';

export const createExperimentsBuilder = () => {
  return unleash
    .getAllToggles()
    .map((toggle) => {
      if (!toggle.enabled || !['experiment', 'release'].includes(toggle.type)) {
        return undefined;
      }
      return {
        platform: config.provider,
        id: toggle.name,
        variant: toggle.variant.name,
        name: toggle.name,
      };
    })
    .filter(isTruthy);
};
